import { Skeleton } from './ui/skeleton';

const TableRowSkeleton = ({ columnCount }: { columnCount: number }) => (
  <>
    {Array(8)
      .fill(0)
      .map((_, rowIndex) => (
        <tr key={rowIndex} className="animate-pulse border-b border-gray-200">
          {Array(columnCount)
            .fill(0)
            .map((_, colIndex) => (
              <td
                key={colIndex}
                className="h-[60px] border-b border-separator px-[20px] py-3 sm:h-[70px] sm:px-4"
              >
                <Skeleton className="h-6 w-full bg-gray-100" />
              </td>
            ))}
        </tr>
      ))}
  </>
);

export default TableRowSkeleton;
